<template>
    <div class="builder-box">
        <div v-if="!loading" class="builder-box__body-wrapper">
            <v-tools-pages-preview :to="{ name: 'tools.landings' }" :request="request" />
        </div>
    </div>
</template>

<script>
import { setModel } from "../../config/tools-pages";
import { api } from "../../services";

export default {
    name: "ToolsBuilderLandingsPreview",
    mounted() {
        this.load();
    },
    data() {
        return {
            loading: true,
            request: {}
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        }
    },
    methods: {
        setModel,
        load() {
            api.landings
                .get(this.id)
                .then(({ data }) => {
                    this.setModel(data.data);
                })
                .finally(() => (this.loading = false));
        }
    }
};
</script>

<style lang="scss" scoped></style>
